@let isEditing = userAssignmentFeatureEc.selectors.isEditing.asSignal();

@if (isEditing) {
  @let accessFlags =
    userAssignmentFeatureEc.selectors.availableAccessFlags.asSignal();
  @let selectedUserIds =
    userAssignmentFeatureEc.selectors.selectedUserIds.asSignal();
  @let mutationError =
    userAssignmentFeatureEc.selectors.mutationErrorMessage.asSignal();

  <atn-ds-centered-overlay>
    <atn-ds-widget title="User Assignment">
      <i
        actions
        class="atn-icon atn-close atn-red"
        (click)="closeIconClickHandler()"
      ></i>
      <div class="atn-admin-user__content">
        <div class="atn-admin-user__input-wrapper">
          <atn-ds-select-multiple
            [config]="{
              overlay: {
                minSearchCharacters: 1,
                hasSearch: true,
              },
            }"
            label="Users"
            [items]="usersSg()"
            [value]="selectedUserIds"
            (valueChange)="selectedUsersChangeHandler($event)"
          />

          @if (canCreateTenantUserSg()) {
            <span
              class="atn-admin-user__link"
              (click)="createNewUserClickHandler()"
            >
              Create New User
            </span>
          }
        </div>

        <div class="atn-admin-user__access">
          <span class="atn-ds-input-field__label">Access</span>
          @for (flag of accessFlags; track flag.value) {
            <div>
              <atn-ds-checkbox
                [label]="flag.label"
                [selected]="isFlagSelected(flag.value)"
                (selectedChange)="accessValueChangeHandler($event, flag.value)"
              ></atn-ds-checkbox>
            </div>
          }
        </div>

        @if (hasAppPagesSg()) {
          <atn-ds-select-multiple
            label="App Pages to Exclude"
            [items]="appPagesToExcludeSg()"
            [value]="excludePagesSg()"
            (valueChange)="excludedAppPagesChangeHandler($event)"
          />

          <atn-ds-select-multiple
            label="App Pages to Include"
            [items]="appPagesToIncludeSg()"
            [value]="includePagesSg()"
            (valueChange)="includedAppPagesChangeHandler($event)"
          />
        }
        <atn-admin-error-message [message]="mutationError" />
      </div>
      <div
        class="atn-admin-user__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelButtonClickHandler()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button (click)="saveClickHandler()">Save</atn-ds-button>
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
